<script>
import ModalBus from '@/eventBus'

export default {
  name: 'BookingModal',

  props: {
    activityInfos: {
      default: {},
    },
  },

  data() {
    return {
      isFetching: false,
    }
  },

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-2xl bg-white md:w-full">
    <div class="item-center flex justify-between border-b-2 border-light/25 p-5">
      <div class="flex items-center lg:text-secondary">
        <span class="font-poppins text-xl font-medium">
          {{ $t('vehicles.quoteForm.title') }}
        </span>
      </div>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <p class="font-sans text-light">
        {{ $t('activities.modal.subtitle') }}
      </p>
      <div class="my-4 flex flex-col text-sm">
        <span
          v-if="activityInfos.manager"
          class="font-sans text-light">
          {{ $t('activities.modal.infos.manager') }} : <span class="font-bold">{{ activityInfos.manager }}</span>
        </span>
        <span
          v-if="activityInfos.phone"
          class="font-sans text-light">
          {{ $t('activities.modal.infos.phone') }} :
          <span class="font-bold text-primary">{{ activityInfos.phone }}</span>
        </span>
        <span
          v-if="activityInfos.email"
          class="font-sans text-light">
          {{ $t('activities.modal.infos.email') }} :
          <span class="font-bold text-primary">{{ activityInfos.email }}</span>
        </span>
        <div
          v-if="activityInfos.content"
          class="wysiwyg"
          v-html="activityInfos.content"></div>
      </div>
      <div class="rounded-2xl border-2 border-primary bg-white p-5 text-sm text-white">
        <div class="flex items-start">
          <svg
            class="mr-4 mt-1 block w-10"
            fill="none"
            height="22"
            viewBox="0 0 34 22"
            width="34"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7698 9.0382L12.9186 8.79298C12.6722 8.75795 12.4258 8.61782 12.3202 8.3726L11.229 5.74521C10.9826 5.1847 10.173 5.1847 9.9266 5.74521L8.8354 8.3726C8.7298 8.61782 8.5186 8.79298 8.237 8.79298L5.3858 9.0382C4.7522 9.07324 4.5058 9.84394 4.9986 10.2643L7.181 12.121C7.3922 12.2962 7.4626 12.5414 7.3922 12.8216L6.6882 15.5892C6.5474 16.1847 7.2162 16.6751 7.7442 16.3599L10.2082 14.8885C10.4194 14.7484 10.701 14.7484 10.9474 14.8885L13.4114 16.3599C13.9394 16.6751 14.6082 16.2197 14.4674 15.5892L13.7986 12.8216C13.7282 12.5764 13.8338 12.2962 14.0098 12.121L16.1922 10.2643C16.6146 9.87897 16.3682 9.10827 15.7698 9.0382Z"
              fill="#469752" />
            <path
              d="M30.096 0H3.344C1.4784 0 0 1.50637 0 3.32803V18.672C0 20.5287 1.5136 22 3.344 22H30.096C31.9616 22 33.44 20.4936 33.44 18.672V3.36306C33.44 1.50637 31.9264 0 30.096 0ZM31.2576 18.707C31.2576 19.3726 30.7296 19.8981 30.0608 19.8981H3.344C2.6752 19.8981 2.1472 19.3726 2.1472 18.707V3.36306C2.1472 2.69745 2.6752 2.17197 3.344 2.17197H30.096C30.7648 2.17197 31.2928 2.69745 31.2928 3.36306L31.2576 18.707Z"
              fill="#469752" />
            <path
              d="M27.4209 4.97449H19.5009C18.9025 4.97449 18.4097 5.46493 18.4097 6.06047C18.4097 6.65602 18.9025 7.14646 19.5009 7.14646H27.4561C28.0545 7.14646 28.5473 6.65602 28.5473 6.06047C28.5121 5.46493 28.0193 4.97449 27.4209 4.97449Z"
              fill="#469752" />
            <path
              d="M27.4209 9.9491H19.5009C18.9025 9.9491 18.4097 10.4395 18.4097 11.0351C18.4097 11.6306 18.9025 12.1211 19.5009 12.1211H27.4561C28.0545 12.1211 28.5473 11.6306 28.5473 11.0351C28.5473 10.4395 28.0193 9.9491 27.4209 9.9491Z"
              fill="#469752" />
            <path
              d="M27.4209 14.9236H19.5009C18.9025 14.9236 18.4097 15.414 18.4097 16.0096C18.4097 16.6051 18.9025 17.0956 19.5009 17.0956H27.4561C28.0545 17.0956 28.5473 16.6051 28.5473 16.0096C28.5121 15.414 28.0193 14.9236 27.4209 14.9236Z"
              fill="#469752" />
          </svg>

          <p class="font-bold text-primary">
            {{ $t('activities.modal.premium') }}
          </p>
        </div>
      </div>
      <div class="mt-6 flex w-full flex-col md:flex-row">
        <a
          :href="activityInfos.link"
          class="btn mb-4 w-full md:mb-0 md:mr-2"
          target="_blank"
          rel="nofollow noopener noreferrer"
          >{{ $t('buttons.bookingSite') }}</a
        >
        <button
          class="btn w-full border border-secondary bg-white text-secondary md:ml-2"
          @click="$emit('close')">
          {{ $t('buttons.backToActivity') }}
        </button>
      </div>
    </div>
  </div>
</template>
